import React from 'react';
import { Feature } from '../../components';
import card from '../../assets/Member-Card-Pantja-Laundry.png';

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

import './about.css';

const About = () => {
  return (
    <div className="pl__about section__margin" id='tentang'>
      <div className="pl__about-container">
        <div className='pl__about-container_text'>
          <h1 className='pl__about-container_text_seo'>Online Laundry</h1>
          <h1 className="gradient__text">Sedjak 2015</h1>
          <p>Pantja Laundry adalah Laundry Online yang mudah dan hemat. Kami memiliki konsep cuci dan setrika ala rumahan, semua perkerjaan yang dikerjakan oleh binatu lebih teliti dan bersih.</p>
          <p>Bukan cuma mengandalkan 1 mesin untuk 1 customer, tetapi kami memperhatikan setiap cucian yang Anda titipkan akan Anda terima dengan bersih!</p>
        </div>
        <div className="pl__about-container_image">
          <AnimationOnScroll animateIn="animate__zoomIn">
            <img src={card} alt="Member Card di Panca Laundry Murah Terdekat" />
          </AnimationOnScroll>
      </div>
      </div>
      <div className="pl__about-features">
      <Feature title="Free Pickup" text="Kami menyediakan layanan FREE PICKUP sampai dengan 5Km dari jangkauan laundry kami. " />
      <Feature title="Guarantee Member" text="Fasilitas Membership garansi uang kembali jika cucian yang Anda terima tidak bersih" />
      <Feature title="Member Point" text="Kumpulkan Point member Anda di aplikasi untuk mendapatkan cashback melimpah." />
      </div>
    </div>
  )
}

export default About